import { getLocationItemData } from "./location-item-column";

export const excelLocationId = (worksheet: any, locationsTable: any[]): any => {
  if (!worksheet) {
    return;
  }

  if (!locationsTable || locationsTable.length === 0) {
    return;
  }

  const data = locationsTable.map((e: any) => [e.code]);

  worksheet.addRows(data);

  return locationsTable;
};

export const excelLocation = (
  worksheet: any,
  t: any,
  locationsTable: any[]
): any => {
  if (!worksheet) {
    return;
  }

  if (!locationsTable || locationsTable.length === 0) {
    return;
  }

  const data = getLocationItemData(locationsTable, t);

  worksheet.addRows(data);

  return locationsTable;
};
